import React, { useState } from 'react';
import { MagicLink } from '@/components/custom/magic-link';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { searchTextLink } from '@/app/services/linkable.js';
import api from '@/app/services/api';
import { useTranslation } from 'react-i18next';
import { FiLoader, FiSend } from 'react-icons/fi';
import { Button } from '@/components/ui/button';
import { PostForm } from '@/components/custom/post';
import { TextareaAutosize } from '@/components/ui/textarea-autosize';

export function PostShare({ addPosts, selectedClassroomId }) {
  const { t } = useTranslation();
  const [text, setText] = useState('');
  const [magicLinks, setMagicLinks] = useState([]);
  const [magicLinkRemoved, setMagicLinkRemoved] = useState(false);
  const [checkingLink, setCheckingLink] = useState(false);
  const [showMagicLink, setShowMagicLink] = useState(true);
  const client = useClient();

  const createPost = e => {
    e.preventDefault();
    if (!checkingLink) {
      const params = {
        data: {
          type: 'Post',
          attributes: {
            body: text,
            'classroom-id': selectedClassroomId?.value === 'blank' || !selectedClassroomId?.value ? null : selectedClassroomId?.value
          },

          relationships: { 'magic-links': { data: showMagicLink ? magicLinks : [] } }
        }
      };
      client
        .mutate('posts', undefined, { body: JSON.stringify(params) })
        .then(response => {
          const { data, error } = response;
          if (error) {
            toast.error(error.title);
          } else {
            setText('');
            setMagicLinks([]);
            setMagicLinkRemoved(false);
            toast.success(t('toast.successSendMessage'));
            addPosts(data);
          }
        })
        .catch(() => {
          toast.error(t('toast.error'));
        });
    }
  };

  const getLinkInfo = async url => {
    return new Promise(function (resolve, reject) {
      api
        .get(`link_infos/search?url=${url}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          setCheckingLink(false);
        });
    });
  };

  const checkHasLink = e => {
    if (!magicLinkRemoved) {
      let bodyText = e.target.value + ' ';
      let links = searchTextLink(bodyText);
      if (links.length > 0) {
        setCheckingLink(true);
        setMagicLinkRemoved(true);
        getLinkInfo(links[0]).then(magicLink => {
          setMagicLinks([magicLink]);
          setCheckingLink(false);
        });
      }
    }
  };

  return (
    <PostForm>
      <TextareaAutosize
        aria-label={t('feed.textareaPlaceholder')}
        placeholder={t('feed.textareaPlaceholder')}
        onKeyUp={e => checkHasLink(e)}
        onBlur={e => checkHasLink(e)}
        onPaste={e => checkHasLink(e)}
        onChange={e => setText(e.target.value)}
        value={text}
        className="min-h-32 !w-28 grow"
      />

      <Button
        size="icon"
        onClick={e => createPost(e)}
      >
        {checkingLink ? (
          <FiLoader
            size={16}
            className="animate-spinner"
          />
        ) : (
          <FiSend size={16} />
        )}{' '}
        <span className="sr-only">Enviar post</span>
      </Button>

      {showMagicLink &&
        magicLinks.map((magicLink, index) => (
          <MagicLink
            showClose={true}
            setShowMagicLink={setShowMagicLink}
            key={index}
            magicLink={magicLink.attributes}
          />
        ))}
    </PostForm>
  );
}
